(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function () {
    var rows = document.querySelectorAll('.q-cart__row[data-line]');
    if (!rows.length) return;

    function updateLine(line, quantity) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity }),
      }).then(function () {
        window.location.reload();
      });
    }

    rows.forEach(function (row) {
      var line = Number(row.dataset.line);
      var input = row.querySelector('[data-cart-qty]');

      row.querySelectorAll('[data-cart-step]').forEach(function (button) {
        button.addEventListener('click', function () {
          var next = Math.max(0, Number(input.value) + Number(button.dataset.cartStep));
          input.value = next;
          updateLine(line, next);
        });
      });

      input.addEventListener('change', function () {
        updateLine(line, Math.max(0, Number(input.value)));
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  document.querySelectorAll('[data-localization-select]').forEach(function (select) {
    select.addEventListener('change', function () {
      select.form.submit();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var drawer = document.getElementById('QNavDrawer');
    if (!drawer) return;

    var openButton = document.querySelector('[data-nav-open]');
    var closeButton = drawer.querySelector('[data-nav-close]');

    function open() {
      drawer.showModal();
      if (openButton) openButton.setAttribute('aria-expanded', 'true');
    }

    function close() {
      drawer.close();
    }

    if (openButton) openButton.addEventListener('click', open);
    if (closeButton) closeButton.addEventListener('click', close);

    drawer.addEventListener('close', function () {
      if (openButton) openButton.setAttribute('aria-expanded', 'false');
    });

    drawer.addEventListener('click', function (event) {
      if (event.target === drawer) close();
    });
  })();

  // Keep the cart badge in sync when items are added without a page reload.
  document.addEventListener('quetzalli:cart-updated', function (event) {
    var badge = document.querySelector('[data-cart-count]');
    if (!badge) return;

    var count = event.detail.item_count;
    badge.textContent = count;
    badge.toggleAttribute('hidden', count === 0);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-presale"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initialize(root) {
    root.querySelectorAll('[data-q-presale]').forEach(function (section) {
      if (section.dataset.presaleInitialized) return;
      section.dataset.presaleInitialized = 'true';
      var picker = section.querySelector('[data-presale-variant]');
      if (picker) picker.addEventListener('change', function () {
        // Re-render price, availability and selling plan together, including without AJAX.
        var url = new URL(window.location.href);
        url.searchParams.set('variant', picker.value);
        window.location.assign(url.toString());
      });
      var form = section.querySelector('form');
      if (!form) return;
      var quantity = form.querySelector('[name="quantity"]');
      form.querySelectorAll('[data-presale-step]').forEach(function (button) {
        button.addEventListener('click', function () {
          if (!Number.isFinite(quantity.valueAsNumber)) quantity.value = quantity.min || '1';
          if (button.dataset.presaleStep === '1') quantity.stepUp(); else quantity.stepDown();
          quantity.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
      if (form.querySelector('[data-presale-ajax]').value !== 'true') return;
      var submit = form.querySelector('[name="add"]');
      var feedback = form.querySelector('[data-presale-feedback]');
      var cartLink = form.querySelector('.q-presale__cart');
      var busy = false;
      form.addEventListener('submit', async function (event) {
        event.preventDefault();
        if (busy || submit.disabled || !form.reportValidity()) return;
        busy = true;
        submit.disabled = true;
        submit.setAttribute('aria-busy', 'true');
        feedback.textContent = '';
        var added = false;
        var route = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        try {
          var response = await fetch(route + 'cart/add.js', {
            method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form)
          });
          var item = await response.json();
          if (!response.ok) throw new Error(typeof item.description === 'string' ? item.description : feedback.dataset.error);
          added = true;
          feedback.textContent = feedback.dataset.added;
          cartLink.hidden = false;
          var cartResponse = await fetch(route + 'cart.js', { headers: { Accept: 'application/json' } });
          if (!cartResponse.ok) throw new Error('cart refresh failed');
          var cart = await cartResponse.json();
          document.dispatchEvent(new CustomEvent('quetzalli:cart-updated', { detail: cart }));
        } catch (error) {
          feedback.textContent = added ? feedback.dataset.refresh : (error.message || feedback.dataset.error);
        } finally {
          busy = false;
          submit.disabled = false;
          submit.removeAttribute('aria-busy');
        }
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initialize(document); });
  else initialize(document);
  document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    var form = document.getElementById('ProductForm');
    if (!form) return;

    var qtyInput = form.querySelector('.q-qty__input');

    form.querySelectorAll('[data-qty-step]').forEach(function (button) {
      button.addEventListener('click', function () {
        var next = parseInt(qtyInput.value, 10) + parseInt(button.dataset.qtyStep, 10);
        qtyInput.value = Math.max(1, next);
      });
    });

    var feedback = form.querySelector('[data-add-feedback]');
    var submit = form.querySelector('[type="submit"]');

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      submit.setAttribute('aria-disabled', 'true');
      feedback.textContent = '';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
      })
        .then(function (response) {
          return response.json().then(function (data) {
            if (!response.ok) throw new Error(data.description || data.message);
            return data;
          });
        })
        .then(function () {
          feedback.textContent = feedback.dataset.addedLabel;

          return fetch('/cart.js', {
            headers: { Accept: 'application/json' }
          }).then(function (r) {
            return r.json();
          });
        })
        .then(function (cart) {
          document.dispatchEvent(
            new CustomEvent('quetzalli:cart-updated', { detail: cart })
          );
        })
        .catch(function (error) {
          feedback.textContent = error.message;
        })
        .finally(function () {
          submit.removeAttribute('aria-disabled');
        });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quetzalli-age-gate"]) return;
  try {
    

  (function () {

    var gate =
      document.querySelector('[data-age-gate]');

    if (!gate) return;

    var root =
      document.documentElement;

    if (
      root.classList.contains('q-age-ok')
    ) return;

    var confirmButton =
      gate.querySelector(
        '[data-age-confirm]'
      );

    var declineButton =
      gate.querySelector(
        '[data-age-decline]'
      );


    function remember() {

      var days =
        parseInt(
          gate.getAttribute(
            'data-remember-days'
          ),
          10
        );

      if (
        isNaN(days) ||
        days < 1
      ) {
        days = 30;
      }

      var cookie =
        'q_age_ok=1; path=/; max-age=' +
        days * 86400 +
        '; samesite=lax';

      if (
        window.location.protocol === 'https:'
      ) {
        cookie += '; secure';
      }

      try {

        document.cookie = cookie;

      } catch (error) {

        /*
          Cookies blocked.
          Gate still clears for this page view.
        */

      }

    }


    confirmButton.addEventListener(
      'click',
      function () {

        remember();

        root.classList.add(
          'q-age-ok'
        );

      }
    );


    declineButton.addEventListener(
      'click',
      function () {

        window.location.replace(
          gate.getAttribute(
            'data-decline-url'
          )
        );

      }
    );


    /*
      Keep focus inside the age gate.
    */

    gate.addEventListener(
      'keydown',
      function (event) {

        if (
          event.key !== 'Tab'
        ) return;

        var first =
          confirmButton;

        var last =
          declineButton;

        if (
          event.shiftKey &&
          document.activeElement === first
        ) {

          event.preventDefault();
          last.focus();

        } else if (
          !event.shiftKey &&
          document.activeElement === last
        ) {

          event.preventDefault();
          first.focus();

        }

      }
    );


    document.addEventListener(
      'focusin',
      function (event) {

        if (
          root.classList.contains(
            'q-age-ok'
          )
        ) return;

        if (
          !gate.contains(event.target)
        ) {
          confirmButton.focus();
        }

      }
    );


    confirmButton.focus();

  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quetzalli-reservation"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      var toggles = (root || document).querySelectorAll('[data-coming-soon-toggle]');
      
      Array.prototype.forEach.call(toggles, function (toggle) {
        toggle.addEventListener('click', function () {
          var isExpanded = this.getAttribute('aria-expanded') === 'true';
          var controlsId = this.getAttribute('aria-controls');
          var rows = document.getElementById(controlsId);
          
          if (rows) {
            if (isExpanded) {
              rows.setAttribute('hidden', '');
              this.setAttribute('aria-expanded', 'false');
            } else {
              rows.removeAttribute('hidden');
              this.setAttribute('aria-expanded', 'true');
            }
          }
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init(document);
      });
    } else {
      init(document);
    }

    // The theme editor re-renders sections in place.
    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quetzalli-signup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      var toggles = (root || document).querySelectorAll('[data-coming-soon-toggle]');
      
      Array.prototype.forEach.call(toggles, function (toggle) {
        toggle.addEventListener('click', function () {
          var isExpanded = this.getAttribute('aria-expanded') === 'true';
          var controlsId = this.getAttribute('aria-controls');
          var rows = document.getElementById(controlsId);
          
          if (rows) {
            if (isExpanded) {
              rows.setAttribute('hidden', '');
              this.setAttribute('aria-expanded', 'false');
            } else {
              rows.removeAttribute('hidden');
              this.setAttribute('aria-expanded', 'true');
            }
          }
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init(document);
      });
    } else {
      init(document);
    }

    // The theme editor re-renders sections in place.
    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
